import CustomerService from 'daishu-customer-service-entry'
import { getUserInfoV2 } from "@/assets/js/api";
import vm from "@/main"
// window.eventBus = new Vue() // 注册全局事件对象
var customerService = new CustomerService({
  options: {
    // app: 'customerservice',
    // app_id: '1',
    platform: 'tuanjian'
  },
  onTap() {
    // eventBus.$on('customerServiceTap',function(data){});
    // eventBus.$emit('customerServiceTap');
    customerService.link_to(vm)
  }
})

customerService.link_to = function (vm = vm) {
  getUserInfoV2(vm).then((res) => {
    if (res.code === 200) {
      let user_info = res.data.user_info;
      customerService.setOptions({
        user: {
          user_name: user_info.username
            ? encodeURIComponent(user_info.username)
            : "",
          user_id: user_info.id,
          avatar_url: user_info.avatar_url,
          mobile_phone: user_info.mobile_phone,
          sex: user_info.gender || 0,
        },
      });
      customerService.link()
    } else {
      customerService.link()
    }
  });
}
customerService.hide()
export default customerService
